"use client";

import { Link, Stack, Typography } from "@mui/material";
import {
  ONBOARDING_V2_PATHS,
  SUPPORT_PHONE,
  SUPPORT_PHONE_TEL_HREF,
} from "@rmh/defs";
import { useTranslations } from "next-intl";

interface AuthSupportFooterProps {
  /**
   * Where the footer renders within OnboardingFormWrapper. The footer sits
   * outside the paper on desktop and inside it on mobile, so both slots render
   * a copy and toggle visibility by breakpoint.
   */
  placement: "outer" | "inner";
}

/** "New to RightMove?" + support phone block shown beneath the auth forms. */
export const AuthSupportFooter = ({ placement }: AuthSupportFooterProps) => {
  const t = useTranslations("onboardingV2.signIn");
  const tFooter = useTranslations("onboardingV2.footer");

  return (
    <Stack
      spacing={6}
      sx={(theme) => ({
        textAlign: "center",
        marginTop: 4,
        display: placement === "inner" ? "flex" : "none",
        [theme.breakpoints.up("md")]: {
          display: placement === "outer" ? "flex" : "none",
        },
      })}
    >
      <Typography variant="bodyMdRegular" color="text.secondary">
        {t.rich("signUpPrompt", {
          link: (chunks) => (
            <Link href={ONBOARDING_V2_PATHS.SIGN_UP}>{chunks}</Link>
          ),
        })}
      </Typography>
      <Typography variant="bodyMdRegular" color="text.secondary">
        {tFooter.rich("supportPrompt", {
          phone: SUPPORT_PHONE,
          hyperlink: (chunks) => (
            <Link href={SUPPORT_PHONE_TEL_HREF} underline="hover">
              {chunks}
            </Link>
          ),
        })}
      </Typography>
    </Stack>
  );
};
